import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import { ShimmerPostList } from "react-shimmer-effects";
import { deleteDefect, getDefects } from "../../../actions/defect/defect";
import DefectsListComponent from "../../../components/Definition/Defects/DefectsListComponent";
import { deleteDelays } from "../../../actions/delay/delay";

export default function DefectsScreen() {
    const [destination, setDestination] = useState({ data: [], links: {} });
    const [loading, setLoading] = useState(true);
    const [status, setStatusDelete] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        setLoading(true);
        const fetchApi = async () => {
            const params = new URLSearchParams(searchParams);
            try {
                const usersData = await getDefects(params.toString());
                setLoading(false);
                setDestination(usersData.status !== "error" ? usersData.message : { data: [], links: {} });
            } catch (error) {
                toast.error('خطا در اتصال به سرور!');
                setLoading(false);
            }
        };

        fetchApi();
    }, [searchParams,status]);

    return (
        <DashboardLayout>
            {loading ? <ShimmerPostList postStyle="STYLE_THREE" col={1} row={3} gap={30} /> : <DefectsListComponent lists={destination} deleteInvoke={async(id)=>{
                const prompt = window.confirm("آیا میخواهید نقص فنی حذف شود ؟ با این کار گزارشات وابسته از بین خواهد رفت")
                if(prompt){
                    const response = await deleteDefect(id);
                    if (response.status === "success") {
                        toast.success("نقص فنی حذف شد!");
                        setStatusDelete(true);
                    } else {
                        toast.error("خطا در حذف نقص فنی");
                    }
                }
            }} />}
        </DashboardLayout>
    );
}
